import { render } from "./JIMScheduling.vue?vue&type=template&id=120b645d&scoped=true"
import script from "./JIMScheduling.vue?vue&type=script&lang=js"
export * from "./JIMScheduling.vue?vue&type=script&lang=js"

import "./JIMScheduling.vue?vue&type=style&index=0&id=120b645d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120b645d"]])

export default __exports__